var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_46_1",
    "data-name": "Component 46 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_17195",
    "data-name": "Rectangle 17195",
    fill: "#fff",
    stroke: "#0466c8",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    rx: 3.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "noun_Login_3323716",
    transform: "translate(27.685 10) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Login",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8950",
    "data-name": "Path 8950",
    d: "M0,15.278v3.6a.832.832,0,0,0,1.665,0v-3.6A5.99,5.99,0,0,1,7.646,9.3H9.133L7.462,10.966a.832.832,0,1,0,1.177,1.177l3.092-3.092a.827.827,0,0,0,.1-.127.666.666,0,0,0,.035-.064.8.8,0,0,0,.042-.079.854.854,0,0,0,.026-.083.7.7,0,0,0,.021-.071.828.828,0,0,0,0-.326.7.7,0,0,0-.021-.071.491.491,0,0,0-.068-.164c-.012-.021-.021-.042-.035-.063a.827.827,0,0,0-.1-.127L8.639,4.783A.832.832,0,1,0,7.461,5.96L9.133,7.631H7.646A7.658,7.658,0,0,0,0,15.278Zm12.712,4.435H4.966a.832.832,0,1,1,0-1.665h7.747a2.083,2.083,0,0,0,2.081-2.081V3.745a2.083,2.083,0,0,0-2.081-2.081H3.746A2.083,2.083,0,0,0,1.665,3.745V6.8A.832.832,0,0,1,0,6.8V3.745A3.75,3.75,0,0,1,3.746,0h8.967a3.75,3.75,0,0,1,3.746,3.745V15.968a3.75,3.75,0,0,1-3.746,3.745Z",
    transform: "translate(0 0)",
    fill: "#0466c8",
    stroke: "#0466c8",
    strokeWidth: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImport);
export default __webpack_public_path__ + "static/media/import.5d334636.svg";
export { ForwardRef as ReactComponent };